module.exports = __webpack_public_path__ + "static/IMG-20201230-WA0002-3dfff25fe2c25c334e323d19d2f19c38.jpg";